import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea } from 'semantic-ui-react'
import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLClient, WindowLocationClient} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function FundingTransferComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}

	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			account:'',
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/client/fundingtransfer/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/

	/*-------------------------------------------------------------------------
	 Forms: Adding and Updating
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		account_name:'',
		account_number:'',
		bank_name:'',
		country:'',
		swiftcode:'',
		bsb_number:'',
		iban:'',
		amount_usd:'',
	});
	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let value = {
			account_name:values.account_name,
			account_number:values.account_number,
			bank_name:values.bank_name,
			country:values.country,
			swiftcode:values.swiftcode,
			bsb_number:values.bsb_number,
			iban:values.iban,
			amount_usd:values.amount_usd
		}

		let formData = new FormData();
		formData.append('type','add');
		formData.append('info',JSON.stringify(value));
		axios.post('/client/fundingtransfer/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Data successfully send."}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Data not successfully send. Please try again later.",footer:'yes'}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}



	useEffect(()=>{
		TableList(pagenumber,search);
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={insertvalidations}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps


						return(
			         <div className="panel hasbottom">
			            <div className="panel-header">Funding Transfer</div>
			            <div className="panel-body">

									 <div className="formtwo-wrapper">
									 		<div>
										  <div className="inlinformtwo">
 											<div><label>Account Name</label></div>
 											<div>
 											<Form.Group widths="equal">
 												<Field name="account_name">
 														{({ field, form }) => (
 														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
 															<Input {...field} onChange={handleChange}/>
 															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
 														</Form.Field>
 														)}
 												</Field>
 											</Form.Group>
 											</div>
 									 </div>{/*.inlinform*/}

									 <div className="inlinformtwo">
										<div><label>Account Number</label></div>
										<div>
										<Form.Group widths="equal">
											<Field name="account_number">
													{({ field, form }) => (
													<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<Input {...field} onChange={handleChange}/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										</div>
								 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											<div><label>Bank Name</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="bank_name">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											<div><label>Country</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="country">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											<div><label>Swift Code</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="swiftcode">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

									 <div className="inlinformtwo">
										<div><label>BSB Number</label></div>
										<div>
										<Form.Group widths="equal">
											<Field name="bsb_number">
													{({ field, form }) => (
													<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<Input {...field} onChange={handleChange}/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										</div>
								 </div>{/*.inlinform*/}

								 <div className="inlinformtwo">
									<div><label>IBAN</label></div>
									<div>
									<Form.Group widths="equal">
										<Field name="iban">
												{({ field, form }) => (
												<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
													<Input {...field} onChange={handleChange}/>
													{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
												</Form.Field>
												)}
										</Field>
									</Form.Group>
									</div>
							 </div>{/*.inlinform*/}

							 <div className="inlinformtwo">
								<div><label>Amount (USD)</label></div>
								<div>
								<Form.Group widths="equal">
									<Field name="amount_usd">
											{({ field, form }) => (
											<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
												<Input {...field} onChange={handleChange}/>
												{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
											</Form.Field>
											)}
									</Field>
								</Form.Group>
								</div>
						 </div>{/*.inlinform*/}




							</div>{/*.left column*/}


							<div></div>{/*.right column*/}

							</div>{/*.end wrapper*/}


									</div>{/*.panel-body*/}
			            <div className="panel-footer">
											<Button className='secondary' size='large' icon="send" content='SEND' onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>

					<div className="panel">
						 <div className="panel-header">Funding Transfer List</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled singleLine unstackable>
									 <Table.Header>
										 <Table.Row>
											 <Table.HeaderCell>Account Name</Table.HeaderCell>
											 <Table.HeaderCell>Account Number</Table.HeaderCell>
											 <Table.HeaderCell>Bank Name</Table.HeaderCell>
											 <Table.HeaderCell>Country</Table.HeaderCell>
											 <Table.HeaderCell>Swift Code</Table.HeaderCell>
											 <Table.HeaderCell>BSB Number</Table.HeaderCell>
											 <Table.HeaderCell>IBAN</Table.HeaderCell>
											 <Table.HeaderCell>Amount (USD)</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='8' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key}>
															 <Table.Cell>{data.account_name}</Table.Cell>
															 <Table.Cell>{data.account_number}</Table.Cell>
															 <Table.Cell>{data.bank_name}</Table.Cell>
															 <Table.Cell>{data.country}</Table.Cell>
															 <Table.Cell>{data.swiftcode}</Table.Cell>
															 <Table.Cell>{data.bsb_number}</Table.Cell>
															 <Table.Cell>{data.iban}</Table.Cell>
															 <Table.Cell>{data.amount_usd}</Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='8'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>
						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
